import { render, staticRenderFns } from "./StaticPagePreview.vue?vue&type=template&id=44a32fc7&"
import script from "./StaticPagePreview.vue?vue&type=script&lang=js&"
export * from "./StaticPagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports